/** ----------------------------------------
    Imports
---------------------------------------- */

import { mapState, mapGetters } from 'vuex';
import { AppStore } from '@interface/store/App';
import store from '@store/store';

/** ----------------------------------------
    Plugin
---------------------------------------- */

const AppPlugin = {
    install(Vue) {

        Vue.mixin({

            data() {
                return {
                    isMounted: false,
                    currency: {
                        decimal: ',',
                        thousands: '.',
                        prefix: '',
                        suffix: '',
                        precision: 0
                    }
                };
            },

            mounted() {
                this.isMounted = true;
            },

            computed: {
                ...mapState({ 
                    authUser: (state: AppStore) => state.user,
                    stateOrganisations: (state: AppStore) => (state.organisation) ? state.organisation.list : {},
                    stateProject: (state: AppStore) => state.project,
                    stateNotifications: (state: AppStore) => state.notification,
                }),

                ...mapGetters({
                    isLoggedIn: 'user/isLoggedIn',
                    userFullName: 'user/fullName',
                    userCommunityName: 'user/communityName',
                    userSalutation: 'user/salutation',
                    userInitials: 'user/initials',
                    notificationTotalUnread: 'notification/totalUnread'
                }),
            },

            methods: {
                trans(value, ...args) {
                    let trans = store.state.trans.data[value];

                    if (!trans) return value;

                    if (args.length)
                        args.map((arg, i) => `{{${ i }}}`)
                            .forEach((val, i) => trans = trans.replace(val, args[i]));
                    
                    return trans;
                }
            }
        });
    }
};

/** ----------------------------------------
    Exports
---------------------------------------- */

export default AppPlugin;